// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"219":"bb586147","395":"6764d75b"}[chunkId] + ".js";
};